window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
			Shopify.theme.name +
			" %c -> https://hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}
hoculus.utils = class {
	static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static async getScriptAsync(source, isModule = false, isNoModule = false) {
		return await new Promise(function (resolve, reject) {
			hoculus.loadedScripts = hoculus.loadedScripts || [];
			if (hoculus.loadedScripts.includes(source) || source == "") {
				resolve(true);
			} else {
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];

				script.defer = 1;
				
				if (isModule) script.type = "module";
				if (isNoModule) script.noModule = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 50);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	}
}

hoculus.utils.domreadyState().then(async () => {
	hoculus.utils.getScriptAsync("//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js", false, false);
})